import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login/Login'
import auth from '@/views/auth/auth'
import Point from '@/views/point/Point'
import FrameIndex from '@/views/index/FrameIndex'
/* import FrameIndex1 from '@/views/index/FrameIndex1' */
/* import Index from '@/views/Index' */

import Home from '@/views/home/Home'
import Topu from '@/views/topu/Topu'
import Worksheet from '@/views/worksheet/Worksheet'
import MakeWorksheet from '@/views/worksheet/MakeWorksheet'
import DetailWorksheet from '@/views/worksheet/DetailWorksheet'
import CustomerSer from '@/views/customerSer/CustomerSer'
import ChatBox from '@/views/customerSer/ChatBox'
import Mine from '@/views/mine/mine'
import Report from '@/views/report/Report'



/* import Topu from '@/views/topu/Topu' */
import Asset from '@/views/asset/Asset'
import Monitor from '@/views/monitor/Monitor'
import MonitorDetail from '@/views/monitor/MonitorDetail'


import Device from '@/views/device/Device'

import Mine1 from '@/views/mine/mine1'

Vue.use(Router)

/*var components = [
	'index'
]

var routers = [];
for(let comp of components){
	var rs = require('../views/'+comp+'/router.js')
	routers = routers.concat(rs.router)
}*/

export default new Router({
  mode: 'hash',
  linkActiveClass:'active',
  linkExactActiveClass:'active',
  routes: [
    {
       path: '',
       name: 'Login',
       component: Login
    },{
		path: '*/login',
		name: 'Login',
		component: Login
	},{
    	path:'/point',
    	name:'Point',
    	component: Point,
		
    },{
    	path:'/auth',
    	name:'auth',
    	component: auth,
		
    },{
		path:'/index',
		component:FrameIndex,
		children:[
			{
				path:'',
				name:'home',
				component:Home
			},{
				path:'topu',
				name:'topu',
				component:Topu
			},{
				path:'worksheet',
				name:'worksheet',
				component:Worksheet
			},{
				path:'report',
				name:'report',
				component:Report
			},{
				path:'customerSer',
				name:'customerSer',
				component:CustomerSer
			},{
				path:'mine',
				name:'mine',
				component:Mine
			}
		]
	},{
    	path:'/asset',
    	name:'Asset',
    	component:Asset,
    },{
		path:'/worksheet',
		name:'worksheet',
		component:Worksheet,
	},{
		path:'/report',
		name:'report',
		component:Report,
	},{
		path:'/editWorksheet',
		name:'editWorksheet',
		component:MakeWorksheet
	},{
		path:'/detailWorksheet',
		name:'detailWorksheet',
		component:DetailWorksheet
	},{
		path:'/monitor',
		name:'monitor',
		component:Monitor
	},{
		path:'/monitorDetail',
		name:'monitorDetail',
		component:MonitorDetail
	},{
		path:'/device',
		name:'device',
		component:Device
	},{
		path:'/mine1',
		component:Mine1
	},{
		path:'/chatBox',
		name:'chatBox',
		component:ChatBox
	}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js